/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppCoverageRouteImport } from './routes/_app/coverage'
import { Route as AppEvidenceRouteImport } from './routes/_app/evidence'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppOutcomesRouteImport } from './routes/_app/outcomes'
import { Route as AppPainPointsRouteImport } from './routes/_app/pain-points'
import { Route as AppPathsRouteImport } from './routes/_app/paths'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppSignalsRouteImport } from './routes/_app/signals'
import { Route as AppUnderwriterRouteImport } from './routes/_app/underwriter'
import { Route as InsuredPlatformSlugRouteImport } from './routes/insured/$platformSlug'
import { Route as JoinInvitationIdRouteImport } from './routes/join/$invitationId'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginVerifyRouteImport } from './routes/login/verify'
import { Route as ProtectOrgSlugRouteImport } from './routes/protect/$orgSlug'
import { Route as AppAgentsIndexRouteImport } from './routes/_app/agents/index'
import { Route as AppAgentsAgentIdRouteImport } from './routes/_app/agents/$agentId'
import { Route as AppCoverageIndexRouteImport } from './routes/_app/coverage/index'
import { Route as AppCoverageClaimsRouteImport } from './routes/_app/coverage/claims'
import { Route as AppCoverageEndorsementsRouteImport } from './routes/_app/coverage/endorsements'
import { Route as AppCoverageQuoteRouteImport } from './routes/_app/coverage/quote'
import { Route as AppCoverageScenariosRouteImport } from './routes/_app/coverage/scenarios'
import { Route as AppFunnelsIndexRouteImport } from './routes/_app/funnels/index'
import { Route as AppFunnelsFunnelIdRouteImport } from './routes/_app/funnels/$funnelId'
import { Route as AppFunnelsNewRouteImport } from './routes/_app/funnels/new'
import { Route as AppIssuesIndexRouteImport } from './routes/_app/issues/index'
import { Route as AppIssuesIssueIdRouteImport } from './routes/_app/issues/$issueId'
import { Route as AppOutcomesIndexRouteImport } from './routes/_app/outcomes/index'
import { Route as AppOutcomesEconomicsRouteImport } from './routes/_app/outcomes/economics'
import { Route as AppSessionsIndexRouteImport } from './routes/_app/sessions/index'
import { Route as AppSessionsSessionIdRouteImport } from './routes/_app/sessions/$sessionId'
import { Route as AppSignalsIndexRouteImport } from './routes/_app/signals/index'
import { Route as AppSignalsReviewRouteImport } from './routes/_app/signals/review'
import { Route as AppTracesIndexRouteImport } from './routes/_app/traces/index'
import { Route as AppTracesTraceIdRouteImport } from './routes/_app/traces/$traceId'
import { Route as AppUseCasesIndexRouteImport } from './routes/_app/use-cases/index'
import { Route as AppUseCasesUseCaseIdRouteImport } from './routes/_app/use-cases/$useCaseId'
import { Route as AppAgentsAgentIdIndexRouteImport } from './routes/_app/agents/$agentId/index'
import { Route as AppAgentsAgentIdAnalyticsRouteImport } from './routes/_app/agents/$agentId/analytics'
import { Route as AppAgentsAgentIdAuthorityRouteImport } from './routes/_app/agents/$agentId/authority'
import { Route as AppAgentsAgentIdCoverageRouteImport } from './routes/_app/agents/$agentId/coverage'
import { Route as AppAgentsAgentIdProfileRouteImport } from './routes/_app/agents/$agentId/profile'
import { Route as AppAgentsAgentIdScoreRouteImport } from './routes/_app/agents/$agentId/score'
import { Route as AppAgentsAgentIdVersionsRouteImport } from './routes/_app/agents/$agentId/versions'
import { Route as AppCoveragePoliciesPolicyIdRouteImport } from './routes/_app/coverage/policies/$policyId'
import { Route as AppSignalsStudioIndexRouteImport } from './routes/_app/signals/studio/index'
import { Route as AppSignalsStudioDefinitionIdRouteImport } from './routes/_app/signals/studio/$definitionId'
import { Route as AppSignalsStudioNewRouteImport } from './routes/_app/signals/studio/new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppCoverageRoute = AppCoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => AppRoute,
} as any)
const AppEvidenceRoute = AppEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppOutcomesRoute = AppOutcomesRouteImport.update({
  id: '/outcomes',
  path: '/outcomes',
  getParentRoute: () => AppRoute,
} as any)
const AppPainPointsRoute = AppPainPointsRouteImport.update({
  id: '/pain-points',
  path: '/pain-points',
  getParentRoute: () => AppRoute,
} as any)
const AppPathsRoute = AppPathsRouteImport.update({
  id: '/paths',
  path: '/paths',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppSignalsRoute = AppSignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => AppRoute,
} as any)
const AppUnderwriterRoute = AppUnderwriterRouteImport.update({
  id: '/underwriter',
  path: '/underwriter',
  getParentRoute: () => AppRoute,
} as any)
const InsuredPlatformSlugRoute = InsuredPlatformSlugRouteImport.update({
  id: '/insured/$platformSlug',
  path: '/insured/$platformSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinInvitationIdRoute = JoinInvitationIdRouteImport.update({
  id: '/join/$invitationId',
  path: '/join/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginVerifyRoute = LoginVerifyRouteImport.update({
  id: '/login/verify',
  path: '/login/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectOrgSlugRoute = ProtectOrgSlugRouteImport.update({
  id: '/protect/$orgSlug',
  path: '/protect/$orgSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsAgentIdRoute = AppAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AppRoute,
} as any)
const AppCoverageIndexRoute = AppCoverageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCoverageRoute,
} as any)
const AppCoverageClaimsRoute = AppCoverageClaimsRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => AppCoverageRoute,
} as any)
const AppCoverageEndorsementsRoute = AppCoverageEndorsementsRouteImport.update({
  id: '/endorsements',
  path: '/endorsements',
  getParentRoute: () => AppCoverageRoute,
} as any)
const AppCoverageQuoteRoute = AppCoverageQuoteRouteImport.update({
  id: '/quote',
  path: '/quote',
  getParentRoute: () => AppCoverageRoute,
} as any)
const AppCoverageScenariosRoute = AppCoverageScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => AppCoverageRoute,
} as any)
const AppFunnelsIndexRoute = AppFunnelsIndexRouteImport.update({
  id: '/funnels/',
  path: '/funnels/',
  getParentRoute: () => AppRoute,
} as any)
const AppFunnelsFunnelIdRoute = AppFunnelsFunnelIdRouteImport.update({
  id: '/funnels/$funnelId',
  path: '/funnels/$funnelId',
  getParentRoute: () => AppRoute,
} as any)
const AppFunnelsNewRoute = AppFunnelsNewRouteImport.update({
  id: '/funnels/new',
  path: '/funnels/new',
  getParentRoute: () => AppRoute,
} as any)
const AppIssuesIndexRoute = AppIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => AppRoute,
} as any)
const AppIssuesIssueIdRoute = AppIssuesIssueIdRouteImport.update({
  id: '/issues/$issueId',
  path: '/issues/$issueId',
  getParentRoute: () => AppRoute,
} as any)
const AppOutcomesIndexRoute = AppOutcomesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutcomesRoute,
} as any)
const AppOutcomesEconomicsRoute = AppOutcomesEconomicsRouteImport.update({
  id: '/economics',
  path: '/economics',
  getParentRoute: () => AppOutcomesRoute,
} as any)
const AppSessionsIndexRoute = AppSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => AppRoute,
} as any)
const AppSessionsSessionIdRoute = AppSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppSignalsIndexRoute = AppSignalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSignalsRoute,
} as any)
const AppSignalsReviewRoute = AppSignalsReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppSignalsRoute,
} as any)
const AppTracesIndexRoute = AppTracesIndexRouteImport.update({
  id: '/traces/',
  path: '/traces/',
  getParentRoute: () => AppRoute,
} as any)
const AppTracesTraceIdRoute = AppTracesTraceIdRouteImport.update({
  id: '/traces/$traceId',
  path: '/traces/$traceId',
  getParentRoute: () => AppRoute,
} as any)
const AppUseCasesIndexRoute = AppUseCasesIndexRouteImport.update({
  id: '/use-cases/',
  path: '/use-cases/',
  getParentRoute: () => AppRoute,
} as any)
const AppUseCasesUseCaseIdRoute = AppUseCasesUseCaseIdRouteImport.update({
  id: '/use-cases/$useCaseId',
  path: '/use-cases/$useCaseId',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsAgentIdIndexRoute = AppAgentsAgentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAgentsAgentIdRoute,
} as any)
const AppAgentsAgentIdAnalyticsRoute =
  AppAgentsAgentIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppAgentsAgentIdRoute,
  } as any)
const AppAgentsAgentIdAuthorityRoute =
  AppAgentsAgentIdAuthorityRouteImport.update({
    id: '/authority',
    path: '/authority',
    getParentRoute: () => AppAgentsAgentIdRoute,
  } as any)
const AppAgentsAgentIdCoverageRoute =
  AppAgentsAgentIdCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => AppAgentsAgentIdRoute,
  } as any)
const AppAgentsAgentIdProfileRoute = AppAgentsAgentIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAgentsAgentIdRoute,
} as any)
const AppAgentsAgentIdScoreRoute = AppAgentsAgentIdScoreRouteImport.update({
  id: '/score',
  path: '/score',
  getParentRoute: () => AppAgentsAgentIdRoute,
} as any)
const AppAgentsAgentIdVersionsRoute =
  AppAgentsAgentIdVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => AppAgentsAgentIdRoute,
  } as any)
const AppCoveragePoliciesPolicyIdRoute =
  AppCoveragePoliciesPolicyIdRouteImport.update({
    id: '/policies/$policyId',
    path: '/policies/$policyId',
    getParentRoute: () => AppCoverageRoute,
  } as any)
const AppSignalsStudioIndexRoute = AppSignalsStudioIndexRouteImport.update({
  id: '/studio/',
  path: '/studio/',
  getParentRoute: () => AppSignalsRoute,
} as any)
const AppSignalsStudioDefinitionIdRoute =
  AppSignalsStudioDefinitionIdRouteImport.update({
    id: '/studio/$definitionId',
    path: '/studio/$definitionId',
    getParentRoute: () => AppSignalsRoute,
  } as any)
const AppSignalsStudioNewRoute = AppSignalsStudioNewRouteImport.update({
  id: '/studio/new',
  path: '/studio/new',
  getParentRoute: () => AppSignalsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/signup': typeof SignupRoute
  '/activity': typeof AppActivityRoute
  '/coverage': typeof AppCoverageRouteWithChildren
  '/evidence': typeof AppEvidenceRoute
  '/insights': typeof AppInsightsRoute
  '/outcomes': typeof AppOutcomesRouteWithChildren
  '/pain-points': typeof AppPainPointsRoute
  '/paths': typeof AppPathsRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/signals': typeof AppSignalsRouteWithChildren
  '/underwriter': typeof AppUnderwriterRoute
  '/insured/$platformSlug': typeof InsuredPlatformSlugRoute
  '/join/$invitationId': typeof JoinInvitationIdRoute
  '/login/verify': typeof LoginVerifyRoute
  '/protect/$orgSlug': typeof ProtectOrgSlugRoute
  '/login/': typeof LoginIndexRoute
  '/agents/$agentId': typeof AppAgentsAgentIdRouteWithChildren
  '/coverage/claims': typeof AppCoverageClaimsRoute
  '/coverage/endorsements': typeof AppCoverageEndorsementsRoute
  '/coverage/quote': typeof AppCoverageQuoteRoute
  '/coverage/scenarios': typeof AppCoverageScenariosRoute
  '/funnels/$funnelId': typeof AppFunnelsFunnelIdRoute
  '/funnels/new': typeof AppFunnelsNewRoute
  '/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/outcomes/economics': typeof AppOutcomesEconomicsRoute
  '/sessions/$sessionId': typeof AppSessionsSessionIdRoute
  '/signals/review': typeof AppSignalsReviewRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/use-cases/$useCaseId': typeof AppUseCasesUseCaseIdRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/coverage/': typeof AppCoverageIndexRoute
  '/funnels/': typeof AppFunnelsIndexRoute
  '/issues/': typeof AppIssuesIndexRoute
  '/outcomes/': typeof AppOutcomesIndexRoute
  '/sessions/': typeof AppSessionsIndexRoute
  '/signals/': typeof AppSignalsIndexRoute
  '/traces/': typeof AppTracesIndexRoute
  '/use-cases/': typeof AppUseCasesIndexRoute
  '/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/authority': typeof AppAgentsAgentIdAuthorityRoute
  '/agents/$agentId/coverage': typeof AppAgentsAgentIdCoverageRoute
  '/agents/$agentId/profile': typeof AppAgentsAgentIdProfileRoute
  '/agents/$agentId/score': typeof AppAgentsAgentIdScoreRoute
  '/agents/$agentId/versions': typeof AppAgentsAgentIdVersionsRoute
  '/coverage/policies/$policyId': typeof AppCoveragePoliciesPolicyIdRoute
  '/signals/studio/$definitionId': typeof AppSignalsStudioDefinitionIdRoute
  '/signals/studio/new': typeof AppSignalsStudioNewRoute
  '/agents/$agentId/': typeof AppAgentsAgentIdIndexRoute
  '/signals/studio/': typeof AppSignalsStudioIndexRoute
}
export interface FileRoutesByTo {
  '/signup': typeof SignupRoute
  '/activity': typeof AppActivityRoute
  '/evidence': typeof AppEvidenceRoute
  '/insights': typeof AppInsightsRoute
  '/pain-points': typeof AppPainPointsRoute
  '/paths': typeof AppPathsRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/underwriter': typeof AppUnderwriterRoute
  '/insured/$platformSlug': typeof InsuredPlatformSlugRoute
  '/join/$invitationId': typeof JoinInvitationIdRoute
  '/login/verify': typeof LoginVerifyRoute
  '/protect/$orgSlug': typeof ProtectOrgSlugRoute
  '/': typeof AppIndexRoute
  '/login': typeof LoginIndexRoute
  '/coverage/claims': typeof AppCoverageClaimsRoute
  '/coverage/endorsements': typeof AppCoverageEndorsementsRoute
  '/coverage/quote': typeof AppCoverageQuoteRoute
  '/coverage/scenarios': typeof AppCoverageScenariosRoute
  '/funnels/$funnelId': typeof AppFunnelsFunnelIdRoute
  '/funnels/new': typeof AppFunnelsNewRoute
  '/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/outcomes/economics': typeof AppOutcomesEconomicsRoute
  '/sessions/$sessionId': typeof AppSessionsSessionIdRoute
  '/signals/review': typeof AppSignalsReviewRoute
  '/traces/$traceId': typeof AppTracesTraceIdRoute
  '/use-cases/$useCaseId': typeof AppUseCasesUseCaseIdRoute
  '/agents': typeof AppAgentsIndexRoute
  '/coverage': typeof AppCoverageIndexRoute
  '/funnels': typeof AppFunnelsIndexRoute
  '/issues': typeof AppIssuesIndexRoute
  '/outcomes': typeof AppOutcomesIndexRoute
  '/sessions': typeof AppSessionsIndexRoute
  '/signals': typeof AppSignalsIndexRoute
  '/traces': typeof AppTracesIndexRoute
  '/use-cases': typeof AppUseCasesIndexRoute
  '/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/authority': typeof AppAgentsAgentIdAuthorityRoute
  '/agents/$agentId/coverage': typeof AppAgentsAgentIdCoverageRoute
  '/agents/$agentId/profile': typeof AppAgentsAgentIdProfileRoute
  '/agents/$agentId/score': typeof AppAgentsAgentIdScoreRoute
  '/agents/$agentId/versions': typeof AppAgentsAgentIdVersionsRoute
  '/coverage/policies/$policyId': typeof AppCoveragePoliciesPolicyIdRoute
  '/signals/studio/$definitionId': typeof AppSignalsStudioDefinitionIdRoute
  '/signals/studio/new': typeof AppSignalsStudioNewRoute
  '/agents/$agentId': typeof AppAgentsAgentIdIndexRoute
  '/signals/studio': typeof AppSignalsStudioIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/signup': typeof SignupRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/coverage': typeof AppCoverageRouteWithChildren
  '/_app/evidence': typeof AppEvidenceRoute
  '/_app/insights': typeof AppInsightsRoute
  '/_app/outcomes': typeof AppOutcomesRouteWithChildren
  '/_app/pain-points': typeof AppPainPointsRoute
  '/_app/paths': typeof AppPathsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/setup': typeof AppSetupRoute
  '/_app/signals': typeof AppSignalsRouteWithChildren
  '/_app/underwriter': typeof AppUnderwriterRoute
  '/insured/$platformSlug': typeof InsuredPlatformSlugRoute
  '/join/$invitationId': typeof JoinInvitationIdRoute
  '/login/verify': typeof LoginVerifyRoute
  '/protect/$orgSlug': typeof ProtectOrgSlugRoute
  '/_app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_app/agents/$agentId': typeof AppAgentsAgentIdRouteWithChildren
  '/_app/coverage/claims': typeof AppCoverageClaimsRoute
  '/_app/coverage/endorsements': typeof AppCoverageEndorsementsRoute
  '/_app/coverage/quote': typeof AppCoverageQuoteRoute
  '/_app/coverage/scenarios': typeof AppCoverageScenariosRoute
  '/_app/funnels/$funnelId': typeof AppFunnelsFunnelIdRoute
  '/_app/funnels/new': typeof AppFunnelsNewRoute
  '/_app/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/_app/outcomes/economics': typeof AppOutcomesEconomicsRoute
  '/_app/sessions/$sessionId': typeof AppSessionsSessionIdRoute
  '/_app/signals/review': typeof AppSignalsReviewRoute
  '/_app/traces/$traceId': typeof AppTracesTraceIdRoute
  '/_app/use-cases/$useCaseId': typeof AppUseCasesUseCaseIdRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/coverage/': typeof AppCoverageIndexRoute
  '/_app/funnels/': typeof AppFunnelsIndexRoute
  '/_app/issues/': typeof AppIssuesIndexRoute
  '/_app/outcomes/': typeof AppOutcomesIndexRoute
  '/_app/sessions/': typeof AppSessionsIndexRoute
  '/_app/signals/': typeof AppSignalsIndexRoute
  '/_app/traces/': typeof AppTracesIndexRoute
  '/_app/use-cases/': typeof AppUseCasesIndexRoute
  '/_app/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/_app/agents/$agentId/authority': typeof AppAgentsAgentIdAuthorityRoute
  '/_app/agents/$agentId/coverage': typeof AppAgentsAgentIdCoverageRoute
  '/_app/agents/$agentId/profile': typeof AppAgentsAgentIdProfileRoute
  '/_app/agents/$agentId/score': typeof AppAgentsAgentIdScoreRoute
  '/_app/agents/$agentId/versions': typeof AppAgentsAgentIdVersionsRoute
  '/_app/coverage/policies/$policyId': typeof AppCoveragePoliciesPolicyIdRoute
  '/_app/signals/studio/$definitionId': typeof AppSignalsStudioDefinitionIdRoute
  '/_app/signals/studio/new': typeof AppSignalsStudioNewRoute
  '/_app/agents/$agentId/': typeof AppAgentsAgentIdIndexRoute
  '/_app/signals/studio/': typeof AppSignalsStudioIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signup'
    | '/activity'
    | '/coverage'
    | '/evidence'
    | '/insights'
    | '/outcomes'
    | '/pain-points'
    | '/paths'
    | '/settings'
    | '/setup'
    | '/signals'
    | '/underwriter'
    | '/insured/$platformSlug'
    | '/join/$invitationId'
    | '/login/verify'
    | '/protect/$orgSlug'
    | '/login/'
    | '/agents/$agentId'
    | '/coverage/claims'
    | '/coverage/endorsements'
    | '/coverage/quote'
    | '/coverage/scenarios'
    | '/funnels/$funnelId'
    | '/funnels/new'
    | '/issues/$issueId'
    | '/outcomes/economics'
    | '/sessions/$sessionId'
    | '/signals/review'
    | '/traces/$traceId'
    | '/use-cases/$useCaseId'
    | '/agents/'
    | '/coverage/'
    | '/funnels/'
    | '/issues/'
    | '/outcomes/'
    | '/sessions/'
    | '/signals/'
    | '/traces/'
    | '/use-cases/'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/authority'
    | '/agents/$agentId/coverage'
    | '/agents/$agentId/profile'
    | '/agents/$agentId/score'
    | '/agents/$agentId/versions'
    | '/coverage/policies/$policyId'
    | '/signals/studio/$definitionId'
    | '/signals/studio/new'
    | '/agents/$agentId/'
    | '/signals/studio/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signup'
    | '/activity'
    | '/evidence'
    | '/insights'
    | '/pain-points'
    | '/paths'
    | '/settings'
    | '/setup'
    | '/underwriter'
    | '/insured/$platformSlug'
    | '/join/$invitationId'
    | '/login/verify'
    | '/protect/$orgSlug'
    | '/'
    | '/login'
    | '/coverage/claims'
    | '/coverage/endorsements'
    | '/coverage/quote'
    | '/coverage/scenarios'
    | '/funnels/$funnelId'
    | '/funnels/new'
    | '/issues/$issueId'
    | '/outcomes/economics'
    | '/sessions/$sessionId'
    | '/signals/review'
    | '/traces/$traceId'
    | '/use-cases/$useCaseId'
    | '/agents'
    | '/coverage'
    | '/funnels'
    | '/issues'
    | '/outcomes'
    | '/sessions'
    | '/signals'
    | '/traces'
    | '/use-cases'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/authority'
    | '/agents/$agentId/coverage'
    | '/agents/$agentId/profile'
    | '/agents/$agentId/score'
    | '/agents/$agentId/versions'
    | '/coverage/policies/$policyId'
    | '/signals/studio/$definitionId'
    | '/signals/studio/new'
    | '/agents/$agentId'
    | '/signals/studio'
  id:
    | '__root__'
    | '/_app'
    | '/signup'
    | '/_app/activity'
    | '/_app/coverage'
    | '/_app/evidence'
    | '/_app/insights'
    | '/_app/outcomes'
    | '/_app/pain-points'
    | '/_app/paths'
    | '/_app/settings'
    | '/_app/setup'
    | '/_app/signals'
    | '/_app/underwriter'
    | '/insured/$platformSlug'
    | '/join/$invitationId'
    | '/login/verify'
    | '/protect/$orgSlug'
    | '/_app/'
    | '/login/'
    | '/_app/agents/$agentId'
    | '/_app/coverage/claims'
    | '/_app/coverage/endorsements'
    | '/_app/coverage/quote'
    | '/_app/coverage/scenarios'
    | '/_app/funnels/$funnelId'
    | '/_app/funnels/new'
    | '/_app/issues/$issueId'
    | '/_app/outcomes/economics'
    | '/_app/sessions/$sessionId'
    | '/_app/signals/review'
    | '/_app/traces/$traceId'
    | '/_app/use-cases/$useCaseId'
    | '/_app/agents/'
    | '/_app/coverage/'
    | '/_app/funnels/'
    | '/_app/issues/'
    | '/_app/outcomes/'
    | '/_app/sessions/'
    | '/_app/signals/'
    | '/_app/traces/'
    | '/_app/use-cases/'
    | '/_app/agents/$agentId/analytics'
    | '/_app/agents/$agentId/authority'
    | '/_app/agents/$agentId/coverage'
    | '/_app/agents/$agentId/profile'
    | '/_app/agents/$agentId/score'
    | '/_app/agents/$agentId/versions'
    | '/_app/coverage/policies/$policyId'
    | '/_app/signals/studio/$definitionId'
    | '/_app/signals/studio/new'
    | '/_app/agents/$agentId/'
    | '/_app/signals/studio/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SignupRoute: typeof SignupRoute
  InsuredPlatformSlugRoute: typeof InsuredPlatformSlugRoute
  JoinInvitationIdRoute: typeof JoinInvitationIdRoute
  LoginVerifyRoute: typeof LoginVerifyRoute
  ProtectOrgSlugRoute: typeof ProtectOrgSlugRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coverage': {
      id: '/_app/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof AppCoverageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/evidence': {
      id: '/_app/evidence'
      path: '/evidence'
      fullPath: '/evidence'
      preLoaderRoute: typeof AppEvidenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outcomes': {
      id: '/_app/outcomes'
      path: '/outcomes'
      fullPath: '/outcomes'
      preLoaderRoute: typeof AppOutcomesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pain-points': {
      id: '/_app/pain-points'
      path: '/pain-points'
      fullPath: '/pain-points'
      preLoaderRoute: typeof AppPainPointsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/paths': {
      id: '/_app/paths'
      path: '/paths'
      fullPath: '/paths'
      preLoaderRoute: typeof AppPathsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/signals': {
      id: '/_app/signals'
      path: '/signals'
      fullPath: '/signals'
      preLoaderRoute: typeof AppSignalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/underwriter': {
      id: '/_app/underwriter'
      path: '/underwriter'
      fullPath: '/underwriter'
      preLoaderRoute: typeof AppUnderwriterRouteImport
      parentRoute: typeof AppRoute
    }
    '/insured/$platformSlug': {
      id: '/insured/$platformSlug'
      path: '/insured/$platformSlug'
      fullPath: '/insured/$platformSlug'
      preLoaderRoute: typeof InsuredPlatformSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$invitationId': {
      id: '/join/$invitationId'
      path: '/join/$invitationId'
      fullPath: '/join/$invitationId'
      preLoaderRoute: typeof JoinInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/verify': {
      id: '/login/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/protect/$orgSlug': {
      id: '/protect/$orgSlug'
      path: '/protect/$orgSlug'
      fullPath: '/protect/$orgSlug'
      preLoaderRoute: typeof ProtectOrgSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$agentId': {
      id: '/_app/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AppAgentsAgentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coverage/': {
      id: '/_app/coverage/'
      path: '/'
      fullPath: '/coverage/'
      preLoaderRoute: typeof AppCoverageIndexRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/coverage/claims': {
      id: '/_app/coverage/claims'
      path: '/claims'
      fullPath: '/coverage/claims'
      preLoaderRoute: typeof AppCoverageClaimsRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/coverage/endorsements': {
      id: '/_app/coverage/endorsements'
      path: '/endorsements'
      fullPath: '/coverage/endorsements'
      preLoaderRoute: typeof AppCoverageEndorsementsRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/coverage/quote': {
      id: '/_app/coverage/quote'
      path: '/quote'
      fullPath: '/coverage/quote'
      preLoaderRoute: typeof AppCoverageQuoteRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/coverage/scenarios': {
      id: '/_app/coverage/scenarios'
      path: '/scenarios'
      fullPath: '/coverage/scenarios'
      preLoaderRoute: typeof AppCoverageScenariosRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/funnels/': {
      id: '/_app/funnels/'
      path: '/funnels'
      fullPath: '/funnels/'
      preLoaderRoute: typeof AppFunnelsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/funnels/$funnelId': {
      id: '/_app/funnels/$funnelId'
      path: '/funnels/$funnelId'
      fullPath: '/funnels/$funnelId'
      preLoaderRoute: typeof AppFunnelsFunnelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/funnels/new': {
      id: '/_app/funnels/new'
      path: '/funnels/new'
      fullPath: '/funnels/new'
      preLoaderRoute: typeof AppFunnelsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/issues/': {
      id: '/_app/issues/'
      path: '/issues'
      fullPath: '/issues/'
      preLoaderRoute: typeof AppIssuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/issues/$issueId': {
      id: '/_app/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/issues/$issueId'
      preLoaderRoute: typeof AppIssuesIssueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outcomes/': {
      id: '/_app/outcomes/'
      path: '/'
      fullPath: '/outcomes/'
      preLoaderRoute: typeof AppOutcomesIndexRouteImport
      parentRoute: typeof AppOutcomesRoute
    }
    '/_app/outcomes/economics': {
      id: '/_app/outcomes/economics'
      path: '/economics'
      fullPath: '/outcomes/economics'
      preLoaderRoute: typeof AppOutcomesEconomicsRouteImport
      parentRoute: typeof AppOutcomesRoute
    }
    '/_app/sessions/': {
      id: '/_app/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof AppSessionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sessions/$sessionId': {
      id: '/_app/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof AppSessionsSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/signals/': {
      id: '/_app/signals/'
      path: '/'
      fullPath: '/signals/'
      preLoaderRoute: typeof AppSignalsIndexRouteImport
      parentRoute: typeof AppSignalsRoute
    }
    '/_app/signals/review': {
      id: '/_app/signals/review'
      path: '/review'
      fullPath: '/signals/review'
      preLoaderRoute: typeof AppSignalsReviewRouteImport
      parentRoute: typeof AppSignalsRoute
    }
    '/_app/traces/': {
      id: '/_app/traces/'
      path: '/traces'
      fullPath: '/traces/'
      preLoaderRoute: typeof AppTracesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traces/$traceId': {
      id: '/_app/traces/$traceId'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId'
      preLoaderRoute: typeof AppTracesTraceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/use-cases/': {
      id: '/_app/use-cases/'
      path: '/use-cases'
      fullPath: '/use-cases/'
      preLoaderRoute: typeof AppUseCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/use-cases/$useCaseId': {
      id: '/_app/use-cases/$useCaseId'
      path: '/use-cases/$useCaseId'
      fullPath: '/use-cases/$useCaseId'
      preLoaderRoute: typeof AppUseCasesUseCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$agentId/': {
      id: '/_app/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AppAgentsAgentIdIndexRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/analytics': {
      id: '/_app/agents/$agentId/analytics'
      path: '/analytics'
      fullPath: '/agents/$agentId/analytics'
      preLoaderRoute: typeof AppAgentsAgentIdAnalyticsRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/authority': {
      id: '/_app/agents/$agentId/authority'
      path: '/authority'
      fullPath: '/agents/$agentId/authority'
      preLoaderRoute: typeof AppAgentsAgentIdAuthorityRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/coverage': {
      id: '/_app/agents/$agentId/coverage'
      path: '/coverage'
      fullPath: '/agents/$agentId/coverage'
      preLoaderRoute: typeof AppAgentsAgentIdCoverageRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/profile': {
      id: '/_app/agents/$agentId/profile'
      path: '/profile'
      fullPath: '/agents/$agentId/profile'
      preLoaderRoute: typeof AppAgentsAgentIdProfileRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/score': {
      id: '/_app/agents/$agentId/score'
      path: '/score'
      fullPath: '/agents/$agentId/score'
      preLoaderRoute: typeof AppAgentsAgentIdScoreRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/versions': {
      id: '/_app/agents/$agentId/versions'
      path: '/versions'
      fullPath: '/agents/$agentId/versions'
      preLoaderRoute: typeof AppAgentsAgentIdVersionsRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/coverage/policies/$policyId': {
      id: '/_app/coverage/policies/$policyId'
      path: '/policies/$policyId'
      fullPath: '/coverage/policies/$policyId'
      preLoaderRoute: typeof AppCoveragePoliciesPolicyIdRouteImport
      parentRoute: typeof AppCoverageRoute
    }
    '/_app/signals/studio/': {
      id: '/_app/signals/studio/'
      path: '/studio'
      fullPath: '/signals/studio/'
      preLoaderRoute: typeof AppSignalsStudioIndexRouteImport
      parentRoute: typeof AppSignalsRoute
    }
    '/_app/signals/studio/$definitionId': {
      id: '/_app/signals/studio/$definitionId'
      path: '/studio/$definitionId'
      fullPath: '/signals/studio/$definitionId'
      preLoaderRoute: typeof AppSignalsStudioDefinitionIdRouteImport
      parentRoute: typeof AppSignalsRoute
    }
    '/_app/signals/studio/new': {
      id: '/_app/signals/studio/new'
      path: '/studio/new'
      fullPath: '/signals/studio/new'
      preLoaderRoute: typeof AppSignalsStudioNewRouteImport
      parentRoute: typeof AppSignalsRoute
    }
  }
}

interface AppCoverageRouteChildren {
  AppCoverageClaimsRoute: typeof AppCoverageClaimsRoute
  AppCoverageEndorsementsRoute: typeof AppCoverageEndorsementsRoute
  AppCoverageQuoteRoute: typeof AppCoverageQuoteRoute
  AppCoverageScenariosRoute: typeof AppCoverageScenariosRoute
  AppCoverageIndexRoute: typeof AppCoverageIndexRoute
  AppCoveragePoliciesPolicyIdRoute: typeof AppCoveragePoliciesPolicyIdRoute
}

const AppCoverageRouteChildren: AppCoverageRouteChildren = {
  AppCoverageClaimsRoute: AppCoverageClaimsRoute,
  AppCoverageEndorsementsRoute: AppCoverageEndorsementsRoute,
  AppCoverageQuoteRoute: AppCoverageQuoteRoute,
  AppCoverageScenariosRoute: AppCoverageScenariosRoute,
  AppCoverageIndexRoute: AppCoverageIndexRoute,
  AppCoveragePoliciesPolicyIdRoute: AppCoveragePoliciesPolicyIdRoute,
}

const AppCoverageRouteWithChildren = AppCoverageRoute._addFileChildren(
  AppCoverageRouteChildren,
)

interface AppOutcomesRouteChildren {
  AppOutcomesEconomicsRoute: typeof AppOutcomesEconomicsRoute
  AppOutcomesIndexRoute: typeof AppOutcomesIndexRoute
}

const AppOutcomesRouteChildren: AppOutcomesRouteChildren = {
  AppOutcomesEconomicsRoute: AppOutcomesEconomicsRoute,
  AppOutcomesIndexRoute: AppOutcomesIndexRoute,
}

const AppOutcomesRouteWithChildren = AppOutcomesRoute._addFileChildren(
  AppOutcomesRouteChildren,
)

interface AppSignalsRouteChildren {
  AppSignalsReviewRoute: typeof AppSignalsReviewRoute
  AppSignalsIndexRoute: typeof AppSignalsIndexRoute
  AppSignalsStudioDefinitionIdRoute: typeof AppSignalsStudioDefinitionIdRoute
  AppSignalsStudioNewRoute: typeof AppSignalsStudioNewRoute
  AppSignalsStudioIndexRoute: typeof AppSignalsStudioIndexRoute
}

const AppSignalsRouteChildren: AppSignalsRouteChildren = {
  AppSignalsReviewRoute: AppSignalsReviewRoute,
  AppSignalsIndexRoute: AppSignalsIndexRoute,
  AppSignalsStudioDefinitionIdRoute: AppSignalsStudioDefinitionIdRoute,
  AppSignalsStudioNewRoute: AppSignalsStudioNewRoute,
  AppSignalsStudioIndexRoute: AppSignalsStudioIndexRoute,
}

const AppSignalsRouteWithChildren = AppSignalsRoute._addFileChildren(
  AppSignalsRouteChildren,
)

interface AppAgentsAgentIdRouteChildren {
  AppAgentsAgentIdAnalyticsRoute: typeof AppAgentsAgentIdAnalyticsRoute
  AppAgentsAgentIdAuthorityRoute: typeof AppAgentsAgentIdAuthorityRoute
  AppAgentsAgentIdCoverageRoute: typeof AppAgentsAgentIdCoverageRoute
  AppAgentsAgentIdProfileRoute: typeof AppAgentsAgentIdProfileRoute
  AppAgentsAgentIdScoreRoute: typeof AppAgentsAgentIdScoreRoute
  AppAgentsAgentIdVersionsRoute: typeof AppAgentsAgentIdVersionsRoute
  AppAgentsAgentIdIndexRoute: typeof AppAgentsAgentIdIndexRoute
}

const AppAgentsAgentIdRouteChildren: AppAgentsAgentIdRouteChildren = {
  AppAgentsAgentIdAnalyticsRoute: AppAgentsAgentIdAnalyticsRoute,
  AppAgentsAgentIdAuthorityRoute: AppAgentsAgentIdAuthorityRoute,
  AppAgentsAgentIdCoverageRoute: AppAgentsAgentIdCoverageRoute,
  AppAgentsAgentIdProfileRoute: AppAgentsAgentIdProfileRoute,
  AppAgentsAgentIdScoreRoute: AppAgentsAgentIdScoreRoute,
  AppAgentsAgentIdVersionsRoute: AppAgentsAgentIdVersionsRoute,
  AppAgentsAgentIdIndexRoute: AppAgentsAgentIdIndexRoute,
}

const AppAgentsAgentIdRouteWithChildren =
  AppAgentsAgentIdRoute._addFileChildren(AppAgentsAgentIdRouteChildren)

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppCoverageRoute: typeof AppCoverageRouteWithChildren
  AppEvidenceRoute: typeof AppEvidenceRoute
  AppInsightsRoute: typeof AppInsightsRoute
  AppOutcomesRoute: typeof AppOutcomesRouteWithChildren
  AppPainPointsRoute: typeof AppPainPointsRoute
  AppPathsRoute: typeof AppPathsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSetupRoute: typeof AppSetupRoute
  AppSignalsRoute: typeof AppSignalsRouteWithChildren
  AppUnderwriterRoute: typeof AppUnderwriterRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAgentsAgentIdRoute: typeof AppAgentsAgentIdRouteWithChildren
  AppFunnelsFunnelIdRoute: typeof AppFunnelsFunnelIdRoute
  AppFunnelsNewRoute: typeof AppFunnelsNewRoute
  AppIssuesIssueIdRoute: typeof AppIssuesIssueIdRoute
  AppSessionsSessionIdRoute: typeof AppSessionsSessionIdRoute
  AppTracesTraceIdRoute: typeof AppTracesTraceIdRoute
  AppUseCasesUseCaseIdRoute: typeof AppUseCasesUseCaseIdRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppFunnelsIndexRoute: typeof AppFunnelsIndexRoute
  AppIssuesIndexRoute: typeof AppIssuesIndexRoute
  AppSessionsIndexRoute: typeof AppSessionsIndexRoute
  AppTracesIndexRoute: typeof AppTracesIndexRoute
  AppUseCasesIndexRoute: typeof AppUseCasesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppCoverageRoute: AppCoverageRouteWithChildren,
  AppEvidenceRoute: AppEvidenceRoute,
  AppInsightsRoute: AppInsightsRoute,
  AppOutcomesRoute: AppOutcomesRouteWithChildren,
  AppPainPointsRoute: AppPainPointsRoute,
  AppPathsRoute: AppPathsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSetupRoute: AppSetupRoute,
  AppSignalsRoute: AppSignalsRouteWithChildren,
  AppUnderwriterRoute: AppUnderwriterRoute,
  AppIndexRoute: AppIndexRoute,
  AppAgentsAgentIdRoute: AppAgentsAgentIdRouteWithChildren,
  AppFunnelsFunnelIdRoute: AppFunnelsFunnelIdRoute,
  AppFunnelsNewRoute: AppFunnelsNewRoute,
  AppIssuesIssueIdRoute: AppIssuesIssueIdRoute,
  AppSessionsSessionIdRoute: AppSessionsSessionIdRoute,
  AppTracesTraceIdRoute: AppTracesTraceIdRoute,
  AppUseCasesUseCaseIdRoute: AppUseCasesUseCaseIdRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppFunnelsIndexRoute: AppFunnelsIndexRoute,
  AppIssuesIndexRoute: AppIssuesIndexRoute,
  AppSessionsIndexRoute: AppSessionsIndexRoute,
  AppTracesIndexRoute: AppTracesIndexRoute,
  AppUseCasesIndexRoute: AppUseCasesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SignupRoute: SignupRoute,
  InsuredPlatformSlugRoute: InsuredPlatformSlugRoute,
  JoinInvitationIdRoute: JoinInvitationIdRoute,
  LoginVerifyRoute: LoginVerifyRoute,
  ProtectOrgSlugRoute: ProtectOrgSlugRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
